declare module PIXI {
	interface TextStyleOptions {
		flashShadow?: boolean;
	}

	interface TextStyle {
		flashShadow?: boolean;
	}
}

class FlashText extends PIXI.Text {
	updateText(respectDirty: boolean) {
		const style = this._style;

		// check if style has changed..
		if (this.localStyleID !== style.styleID) {
			this.dirty = true;
			this.localStyleID = style.styleID;
		}

		if (!this.dirty && respectDirty) {
			return;
		}

		this._font = PIXI.Text.getFontStyle(style);

		this.context.font = this._font;

		// word wrap
		// preserve original text
		const outputText = style.wordWrap ? this.wordWrap(this._text) : this._text;

		// split text into lines
		const lines = outputText.split(/(?:\r\n|\r|\n)/);

		// calculate text width
		const lineWidths = new Array(lines.length);
		let maxLineWidth = 0;
		const fontProperties = PIXI.Text.calculateFontProperties(this._font);

		for (let i = 0; i < lines.length; i++) {
			const lineWidth = this.context.measureText(lines[i]).width + ((lines[i].length - 1) * style.letterSpacing);

			lineWidths[i] = lineWidth;
			maxLineWidth = Math.max(maxLineWidth, lineWidth);
		}

		let width = maxLineWidth + style.strokeThickness;

		if (style.dropShadow) {
			width += style.dropShadowDistance;
		}

		this.canvas.width = Math.ceil((width + (style.padding * 2)) * this.resolution);

		// calculate text height
		const lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;

		let height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness)
			+ ((lines.length - 1) * lineHeight);

		if (style.dropShadow) {
			height += style.dropShadowDistance;
		}

		this.canvas.height = Math.ceil((height + (style.padding * 2)) * this.resolution);

		this.context.scale(this.resolution, this.resolution);

		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

		this.context.font = this._font;
		this.context.strokeStyle = style.stroke as any;
		this.context.lineWidth = style.strokeThickness;
		this.context.textBaseline = style.textBaseline;
		this.context.lineJoin = style.lineJoin;
		this.context.miterLimit = style.miterLimit;

		let linePositionX;
		let linePositionY;


		if (style.flashShadow) {
			//THATS MY CODE!!! 4 diagonals
			//EVERYTHING ELSE IS JUST PIXIJS CODE
			this.context.globalAlpha = 1.0;
			this.context.fillStyle = 'black';

			for (let i = 0; i < lines.length; i++) {
				linePositionX = style.strokeThickness / 2;
				linePositionY = ((style.strokeThickness / 2) + (i * lineHeight)) + fontProperties.ascent;

				if (style.align === 'right') {
					linePositionX += maxLineWidth - lineWidths[i];
				}
				else if (style.align === 'center') {
					linePositionX += (maxLineWidth - lineWidths[i]) / 2;
				}

				for (let dx = -1; dx <= 1; dx += 2)
					for (let dy = -1; dy <= 1; dy += 2) {
						this.drawLetterSpacing(
							lines[i],
							linePositionX + dx + style.padding, linePositionY + dy + style.padding
						);
					}
			}
		} else if (style.dropShadow) {
			this.context.shadowBlur = style.dropShadowBlur;
			this.context.globalAlpha = style.dropShadowAlpha;

			if (style.dropShadowBlur > 0) {
				this.context.shadowColor = style.dropShadowColor as any;
			}
			else {
				this.context.fillStyle = style.dropShadowColor as any;
			}

			const xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
			const yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;

			for (let i = 0; i < lines.length; i++) {
				linePositionX = style.strokeThickness / 2;
				linePositionY = ((style.strokeThickness / 2) + (i * lineHeight)) + fontProperties.ascent;

				if (style.align === 'right') {
					linePositionX += maxLineWidth - lineWidths[i];
				}
				else if (style.align === 'center') {
					linePositionX += (maxLineWidth - lineWidths[i]) / 2;
				}

				if (style.fill) {
					this.drawLetterSpacing(
						lines[i],
						linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding
					);

					if (style.stroke && style.strokeThickness) {
						this.context.strokeStyle = style.dropShadowColor as any;
						this.drawLetterSpacing(
							lines[i],
							linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding,
							true
						);
						this.context.strokeStyle = style.stroke as any;
					}
				}
			}
		}

		// reset the shadow blur and alpha that was set by the drop shadow, for the regular text
		this.context.shadowBlur = 0;
		this.context.globalAlpha = 1;

		// set canvas text styles
		this.context.fillStyle = this._generateFillStyle(style, lines) as any;

		// draw lines line by line
		for (let i = 0; i < lines.length; i++) {
			linePositionX = style.strokeThickness / 2;
			linePositionY = ((style.strokeThickness / 2) + (i * lineHeight)) + fontProperties.ascent;

			if (style.align === 'right') {
				linePositionX += maxLineWidth - lineWidths[i];
			}
			else if (style.align === 'center') {
				linePositionX += (maxLineWidth - lineWidths[i]) / 2;
			}

			if (style.stroke && style.strokeThickness) {
				this.drawLetterSpacing(lines[i], linePositionX + style.padding, linePositionY + style.padding, true);
			}

			if (style.fill) {
				this.drawLetterSpacing(lines[i], linePositionX + style.padding, linePositionY + style.padding);
			}
		}

		this.updateTexture();
	}

	updateTransform() {
		super.updateTransform();
		const transform = this.transform.worldTransform;
		transform.tx = Math.round(transform.tx);
		transform.ty = Math.round(transform.ty);

		if (this.width % 2) {
			transform.tx -= 0.5;
		}
	}
}